import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Assign({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-5.5 0.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M23.143622 27.7075305v-9.3560339c0-.4878305-.2179757-.9459152-.6137561-1.2909661-.395122-.3443898-.9212927-.5347627-1.4810488-.5347627-1.1557317 0-2.0954634.819-2.0954634 1.8257288v7.3214237" />
        <path d="M14.3022415 23.6377814V7.14276441c0-.48716949-.2179756-.94591526-.6137561-1.29030509-.395122-.34505085-.9212927-.53476271-1.4810488-.53476271-1.1557317 0-2.09612197.819-2.09612197 1.8250678V26.7009339c.02107317.2829153-.13631707.5651695-.43595122.7185254-.22456097.114356-.48270731.1322034-.71319512.0700678-.00131707-.000661-.00329268-.000661-.00526829-.001322-.02304878-.0066102-.04609756-.0138814-.0684878-.0218136-.00658537-.002644-.01317074-.0046271-.0197561-.0072712-.01778049-.0066101-.03490244-.0138813-.05202439-.0218135-.01053659-.0046271-.02041464-.0092543-.03029269-.0145424-.01317073-.0059491-.02568292-.0125593-.03819512-.0198305-.01317073-.0072712-.027-.0152034-.03951219-.0231356-.00856098-.0052881-.01712195-.0105763-.02502439-.0158644-.01646342-.0112373-.03292683-.0231356-.04873171-.0356949-.00395122-.0026441-.0072439-.0052882-.01119512-.0085932-.07573171-.0601526-.13895122-.1315424-.18702439-.2115255l-2.2462683-4.7857627c-.47612195-1.1349661-1.57126829-1.5256271-2.42670731-1.5256271-.55053659 0-1.08131708.1474068-1.53373171.4256949C.60599756 22.3223576 1.6056561 24.4766119 1.6129 24.4858661l4.58407317 8.7313729c3.45863415 5.3020169 6.08619513 6.5486949 10.47731703 6.5486949h.4188293c7.4776829 0 10.4713903-3.2323729 10.4713903-13.0141017v-5.4269491c0-.4871695-.2179757-.9459153-.6137561-1.2903051-.3957805-.3450509-.9219513-.5347627-1.4810488-.5347627-1.1557317 0-2.0954634.819-2.0954634 1.8257288v6.3821186" />
        <path d="M18.7229317 25.6728542v-10.296661c0-.4865085-.2179756-.9452542-.6144146-1.2909661-.3944634-.3443898-.9212927-.5341017-1.4803903-.5341017-1.1557317 0-2.0954634.819-2.0954634 1.8250678v8.2613899M16.1955341 11.9238339c1.2117074-1.10389831 1.9769269-2.69232204 1.9769269-4.46384746 0-3.33152542-2.690122-6.03244068-6.0098049-6.03244068-3.31968293 0-6.01046342 2.70091526-6.01046342 6.03244068 0 1.83498305.81921952 3.47562712 2.10665854 4.58216946" />
      </g>
    </svg>
  )
}

Assign.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
